import MessageBroker from '@bonprix/pattern-library/components/message-broker';
import ProductMessages from '../components/message-list';

function onItemChange(onItemChanged) {
    return MessageBroker.subscribe(ProductMessages.CHANGED, ({item, itemOption}) => {
        if(item !== undefined) {
            onItemChanged(item, itemOption);
        }
    });
}

export default {
    onItemChange
}